import React from "react";
import SkeletonCard from "../../../WebPages/super-overview/components/SkeletonCard";

const StatCard = ({
    otherClass = "",
    title = "",
    subtitle = "",
    imgSrc = "",
    value = 0,
    isLoading = false,
    onClick = () => {}
}) => {
    return (
        <>
            <SkeletonCard
                className={`${!isLoading && "d-none"} col-12 col-sm-6 col-md-4 col-lg col-xl mt-3 px-1`}
            />

            <div
                className={`col-12 col-sm-6 col-md-4 col-lg col-xl mt-3 px-1 ${isLoading && "d-none"} ${otherClass}`}
                style={{ cursor: "pointer" }}
                onClick={onClick}
            >
                <a className="superadminboxN">
                    <img src={imgSrc} alt="" className="imgicon mb-2" />
                    <h1 className="titlenumbers">{value}</h1>
                    <h2 className="subtitle">{subtitle}</h2>
                </a>
            </div>
        </>
    );
};

export default StatCard;
